import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
import { login } from '../investors/api';

const V2InvestorLogin = () => {
  useSEO({
    title: 'Investor Login, Keystone',
    description: 'Secure access for approved investors and strategic partners.',
    path: '/investors/login',
    noindex: true,
  });
  const nav = useNavigate();
  const [state, setState] = useState({ submitting: false, error: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setState({ submitting: true, error: '' });
    const f = new FormData(e.currentTarget);
    try {
      await login(f.get('email'), f.get('password'));
      nav('/investors/portal');
    } catch (err) {
      setState({ submitting: false, error: err.message });
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16" data-testid="v2-investor-login">
      <div className="max-w-md w-full mx-auto px-4">
        <div className="text-center mb-8">
          <div className="inline-flex w-12 h-12 rounded-lg bg-slate-900 text-white items-center justify-center mb-4">
            <Lock className="w-5 h-5" />
          </div>
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-2">Investor portal</p>
          <h1 className="text-3xl font-medium tracking-tight text-slate-900">Secure sign in</h1>
          <p className="mt-2 text-sm text-slate-500">Approved investors and strategic partners.</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8 space-y-4" data-testid="investor-login-form">
          <div>
            <label className="block text-xs uppercase tracking-[0.14em] text-slate-500 font-semibold mb-1.5">Email</label>
            <input name="email" type="email" required className="w-full rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-testid="investor-login-email" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.14em] text-slate-500 font-semibold mb-1.5">Password</label>
            <input name="password" type="password" required autoComplete="current-password" className="w-full rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-testid="investor-login-password" />
          </div>
          {state.error && <p className="text-sm text-red-600" data-testid="investor-login-error">{state.error}</p>}
          <button type="submit" disabled={state.submitting} className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-slate-800 disabled:opacity-50 transition-colors" data-testid="investor-login-submit">
            {state.submitting ? 'Signing in…' : (<>Secure Login <ArrowRight className="w-4 h-4" /></>)}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-slate-500">
          Don&rsquo;t have access yet?{' '}
          <Link to="/investors/request-access" className="text-blue-600 hover:text-blue-700">Request Access</Link>
        </p>
      </div>
    </div>
  );
};

export default V2InvestorLogin;
